import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewBookingPageNew from "../../components/Booking/ViewBookingPageNew";

const ViewBookingPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="View"   title2="Booking Management" 
        link2="/booking" 
         />

        <ViewBookingPageNew />
      </MasterLayout>
    </>
  );
};

export default ViewBookingPage;
